import BatchPill from './BatchPill';
export default BatchPill;
